import { ErrorMessage, icons } from "@similarweb/ai-kit";

import { translate } from "app/filters/i18nFilter";

export enum AIAgentErrorCode {
    NO_RESULTS_FROM_TOP_PAGES = "NO_RESULTS_FROM_TOP_PAGES",
    NOT_ENOUGH_DATA = "NOT_ENOUGH_DATA",
}

interface IAIAgentErrorMessageProps {
    errorCode?: string | null;
    keyword?: string;
}

export const AIAgentErrorMessage: React.FC<IAIAgentErrorMessageProps> = ({ errorCode, keyword }) => {
    if (errorCode === AIAgentErrorCode.NOT_ENOUGH_DATA) {
        return (
            <ErrorMessage
                icon={icons.icons.noticeIcon}
                title={translate("ai.agent.seo.error.no_enough_data.title", { keyword })}
                topParagraph={translate("ai.agent.seo.error.no_enough_data.description", { keyword })}
                bottomParagraph={translate("ai.agent.seo.error.no_enough_data.action", { keyword })}
            />
        );
    }
    if (errorCode === AIAgentErrorCode.NO_RESULTS_FROM_TOP_PAGES) {
        return (
            <ErrorMessage
                title={translate("ai.agent.seo.error.no_results.title")}
                topParagraph={translate("ai.agent.seo.error.no_results.description")}
                bottomParagraph={translate("ai.agent.seo.error.no_results.action")}
            />
        );
    }
    return (
        <ErrorMessage
            title={translate("ai.agent.seo.error.title")}
            topParagraph={translate("ai.agent.seo.error.description")}
            bottomParagraph={translate("ai.agent.seo.error.action")}
        />
    );
};
